import { render, staticRenderFns } from "./FacetItem.vue?vue&type=template&id=58786ea2&scoped=true&"
import script from "./FacetItem.vue?vue&type=script&lang=js&"
export * from "./FacetItem.vue?vue&type=script&lang=js&"
import style0 from "./FacetItem.vue?vue&type=style&index=0&id=58786ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58786ea2",
  null
  
)

export default component.exports